import ReactGA from 'react-ga';

function gainit() {
    const trackingId = "UA-41476494-3";
    ReactGA.initialize(trackingId);
}

function gauser(userid) {
    ReactGA.set({userId:userid})
}

function ga(category,action) {
    ReactGA.event({category:category,action:action});
}

export { gainit, gauser, ga };